module.exports = __webpack_public_path__ + "img/Capgemini_white.186ec4d8.png";